export default __webpack_public_path__ + "static/media/element_14.997b480e.avif";